module.exports = __webpack_public_path__ + "static/media/earnedInADay_15000_25000.0e5862f9.png";